// Action types for selecting a template
export const SELECTTEMPLATE = "SELECTTEMPLATE";

// Action types for selecting a resume
export const SELECTRESUME = "SELECTRESUME";

// Action types for adding personal information
export const ADDPERSONALINFO = "ADDPERSONALINFO";

// Action types for adding experience
export const ADDEXPERIENCE = "ADDEXPERIENCE";
export const ADDALLEXPERIENCE = "ADDALLEXPERIENCE";

// Action types for adding and editing skills
export const ADDNEWSKILLS = "ADDNEWSKILLS";
export const DELETESKILL = "DELETESKILL";
export const EDITSKILL = "EDITSKILL";

// Action types for adding education
export const ADDEDUCATION = "ADDEDUCATION";

// Action types for adding, editing, and deleting projects
export const ADDNEWPROJECTS = "ADDNEWPROJECTS";
export const DELETEPROJECT = "DELETEPROJECT";
export const EDITPROJECT = "EDITPROJECT";

// Action types for adding, editing, and deleting achievements
export const ADDNEWACHIEVEMENTS = "ADDNEWACHIEVEMENTS";
export const DELETEACHIEVEMENT= "DELETEACHIEVEMENT";
export const EDITACHIEVEMENT = "EDITACHIEVEMENT";